import type { OMQRecord } from './OMQRecord';
import type { File } from './file';

export enum AccountStateTypes {
  DEMO = 'DEMO',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  TEST = 'TEST',
  DELETING = 'DELETING',
}

/**
 * Type of OMQ Account
 */
export type Account = OMQRecord & {
  state: AccountStateTypes;
  logo: File;

  apiKey: string;
  isApiKeyActive: boolean;

  ocRequestCount: number;
  opUserCount: number;
  osRequestCount: number;
  forceTwoFactorAuth: boolean;
};
